<template>
  <v-form
      ref="form"
      v-model="valid">
    <v-text-field
        label="Your e-mail"
        type="email"
        prepend-inner-icon="fas fa-user"
        :rules="emailRules"
        required
        v-model="user.email"></v-text-field>
    <v-text-field
        label="A super secret password"
        type="password"
        prepend-inner-icon="fas fa-lock"
        :rules="passwordRules"
        required
        v-model="user.password"></v-text-field>
    <transition
        name="fade">
      <p
          v-if="error"
          class="danger-text absolute error--text">
        {{ error }}
      </p>
    </transition>
    <button
        class="button button-primary mb-48 mt-48"
        type="button"
        :disabled="successAccountCreation || !valid"
        @click="registerAccount">
      Register
    </button>

    <transition name="fade">
      <p
          v-if="successAccountCreation"
          class="success-text">
        Nice! Thanks for registering. We are currently creating the account registration form online, but you may
        continue the registration process on the app (it's free and easy)! Click on the buttons below to continue on
        your favourite device.
      </p>
    </transition>
    <transition name="fade">
      <div v-if="successAccountCreation">
        <a href='https://play.google.com/store/apps/details?id=com.koffeestudios.herohire&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'><img
            alt='Get it on Google Play'
            src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'
            style="width: 160px;display: inline-block;position: relative;top: -15px;"/></a>
        <a href="https://apps.apple.com/us/app/hero-hire/id1496489469?mt=8"
           style="display:inline-block;overflow:hidden;background:url(https://linkmaker.itunes.apple.com/en-gb/badge-lrg.svg?releaseDate=2020-07-27&kind=iossoftware&bubble=ios_apps) no-repeat;width: 135px;height: 40px"></a>
      </div>
    </transition>
  </v-form>
</template>

<script>
import firebase from '../../scripts/firebase'

export default {
  name: "RegisterForm",
  data() {
    return {
      valid: true,
      auth: '',
      user: {
        email: '',
        password: ''
      },
      emailRules: [
        v => !!v || 'You need to enter an e-mail',
        v => /.+@.+\..+/.test(v) || 'Your e-mail must be valid',
      ],
      passwordRules: [
        v => !!v || 'You need to enter a password',
        v => (v && v.length >= 8) || 'Your password must be greater than 8 characters',
      ],
      error: '',
      successAccountCreation: false,

    }
  },
  mounted() {
    this.auth = firebase.auth();

    if (this.$store.getters.user.loggedIn) {
      console.error('LOGGED IN')
      this.$router.push('/dashboard')
    }
  },
  methods: {
    registerAccount() {
      this.error = '';

      this.auth.createUserWithEmailAndPassword(this.user.email, this.user.password)
          .then(
              () => {
                this.successAccountCreation = true;
              },
              err => {
                this.successAccountCreation = false;
                this.error = err;
                console.log(err);
              }
          )
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}
</style>
